import { Heading, Layout, Logo } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { getVehicleModelsList } from "../../data/vehicle";
import { TilesSelectGroup } from "../generic/TileSelectGroup";
import { BrandType } from "@bus/models";
export const VehicleModels = () => {
    const { t } = useTranslation(["question1page"]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const getTitle = () => {
        switch (brand) {
            case BrandType.VW:
                return t("question1page:vehicle-models.titleVW");
            case BrandType.VWN:
                return t("question1page:vehicle-models.titleVWN");
            case BrandType.AUDI:
                return t("question1page:vehicle-models.titleAudi");
            case BrandType.SKODA:
                return t("question1page:vehicle-models.titleSkoda");
            case BrandType.SEAT:
                return t("question1page:vehicle-models.titleSeat");
            case BrandType.CUPRA:
                return t("question1page:vehicle-models.titleCupra");
            default:
                return t("question1page:vehicle-models.title");
        }
    }

    return (
        <>
            <Heading level={2} className={'u-font-size-fs2'}>{getTitle()}</Heading>
            {brand !== "seat" ? (
                <TilesSelectGroup
                    list={getVehicleModelsList()}
                    fieldName="models"
                    className="u-1/3 u-1/2@l u-1/1@s VehicleModels"
                    required
                />
            ): (
                <Layout>
                    <Layout.Item default="1/2">
                        <Logo />
                        <br />
                        <TilesSelectGroup
                            list={getVehicleModelsList()}
                            fieldName="models"
                            className="u-1/2 u-1/1@m VehicleModels"
                            required
                        />
                    </Layout.Item>
                    <Layout.Item default="1/2">
                        <Logo
                            style={{
                                display: "flex",
                                alignItems: "center",
                                scale: "2.5",
                                marginLeft: "110px",
                            }}
                            src="https://cdn.bronson.vwfs.io/cupra/v/11.12.0-beta/img/logo.svg"
                        />
                        <br />
                        <TilesSelectGroup
                            showError={false}
                            list={getVehicleModelsList("cupra")}
                            fieldName="models"
                            className="u-1/2 u-1/1@m VehicleModels"
                            required
                        />
                    </Layout.Item>
                </Layout>
            )}
        </>
    );
};
